import camelCase from "lodash/camelCase";
import pluralize from "pluralize";
import { CREATE, DELETE, GET_LIST, GET_MANY, GET_MANY_REFERENCE, GET_ONE, UPDATE, } from "react-admin";
import { makePrefixedFullName } from "./makePrefixedFullName";
export var makeIntrospectionOptions = function (options) {
    var _a;
    var prefix = function (s) { return makePrefixedFullName(s, options === null || options === void 0 ? void 0 : options.aliasPrefix); };
    return {
        operationNames: (_a = {},
            _a[GET_LIST] = function (resource) {
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _a[GET_ONE] = function (resource) { return prefix("" + camelCase(resource.name)); },
            _a[GET_MANY] = function (resource) {
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _a[GET_MANY_REFERENCE] = function (resource) {
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _a[CREATE] = function (resource) { return prefix("createOne" + resource.name); },
            _a[UPDATE] = function (resource) { return prefix("updateOne" + resource.name); },
            _a[DELETE] = function (resource) { return prefix("deleteOne" + resource.name); },
            _a),
        exclude: undefined,
        include: undefined,
    };
};
//# sourceMappingURL=makeIntrospectionOptions.js.map